// src/Form.js
import './asset/App.css';
import React, { useEffect } from 'react';

export default function Courses() {
    window.location.href('https://mastertalks.tw/collections/%E6%9C%83%E8%A8%88%E7%A8%85%E5%8B%99');
    useEffect(() => {
        window.location.href('https://mastertalks.tw/collections/%E6%9C%83%E8%A8%88%E7%A8%85%E5%8B%99');
    
    }, []);

    return (<div></div>);
}